import {
  BlacklistElementOrigin as ApiBlacklistElementOrigin,
  BlacklistElementFragment,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { BlacklistElement, BlacklistElementOrigin } from "src/types/blacklist";

import { mapToAdminStatus } from "./adminStatus.mappers";
import { mapToClientSchemaBlacklist } from "./clientSchema.mappers";
import { mapToElement } from "./element.mappers";
import { mapToPropertyValue } from "./property.mappers";

const ORIGIN_MAP: { [key in ApiBlacklistElementOrigin]: BlacklistElementOrigin } = {
  MANUAL: "manual",
  CASE_IDENTIFIER: "caseIdentifier",
  IMPORT: "import",
};

export const mapToBlacklistElementOrigin = (
  origin: ApiBlacklistElementOrigin
): BlacklistElementOrigin => {
  return ORIGIN_MAP[origin];
};

export const mapToBlacklistElement = (fragment: BlacklistElementFragment): BlacklistElement => {
  return {
    adminStatus: mapToAdminStatus(fragment.adminStatus),
    blacklist: mapToClientSchemaBlacklist(fragment.blacklist),
    sourceProperties:
      fragment.blacklist?.identifier?.sourceProperties?.map((source) => source.code) || [],
    status: !fragment.disabled,
    id: fragment.id,
    origin: fragment.origin ? mapToBlacklistElementOrigin(fragment.origin) : "manual",
    elements: fragment.elements.map(mapToElement),
    properties: fragment.properties.map(mapToPropertyValue),
    sourceCaseType: {
      code: fragment.sourceCaseType?.code || "",
      name: fragment.sourceCaseType?.name || "",
    },
  };
};
